module.exports = __webpack_public_path__ + "img/loginQuoteImage02.e742a20e.webp";